import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { useLanguage } from '../context/LanguageContext';
import { Fade, Bounce } from 'react-awesome-reveal';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

function Notfound() {
  const { d } = useLanguage();
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const paramConfig = {
    particles: {
      number: {
        value: 130,
        density: {
          enable: false
        }
      },
      color: {
        value: "#ffffff"
      },
      opacity: {
        value: 0.1
      },
      size: {
        value: 6,
        random: true,
        anim: {
          enable: true,
          speed: 20
        }
      },
      line_linked: {
        enable: false
      },
      move: {
        random: true,
        speed: 1,
        direction: "bottom",
        out_mode: "out"
      }
    }
  };

  return (
    <Layout>
      {init && <Particles id="tsparticles" className="mi-home-particle" options={paramConfig} />}
      <div className="mi-about-area mi-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="notfound">
                <div className="notfound-inner text-center">
                  <Bounce triggerOnce><h1>{d.notFound.number}</h1></Bounce>
                  <Fade triggerOnce cascade damping={0.2}>
                    <h3>{d.notFound.message}</h3>
                    <h5>{d.notFound.advice}</h5>
                    <a href="/" className="mi-button">
                      {d.notFound.button}
                    </a>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Notfound;
